import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Rule } from "../rule.js";
import { GroupingRule } from "./grouping.js";
/**
 * @public
 */
export class KeyframesRule extends GroupingRule {
    static of(name, rules) {
        return new KeyframesRule(name, Array.from(rules));
    }
    _name;
    constructor(name, rules) {
        super("keyframes", rules);
        this._name = name;
    }
    get name() {
        return this._name;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: this._name,
        };
    }
    toString() {
        const rules = this._rules
            .map((rule) => String.indent(rule.toString()))
            .join("\n\n");
        return `@keyframes ${this._name} {${rules === "" ? "" : `\n${rules}\n`}}`;
    }
}
/**
 * @public
 */
(function (KeyframesRule) {
    function isKeyframesRule(value) {
        return value instanceof KeyframesRule;
    }
    KeyframesRule.isKeyframesRule = isKeyframesRule;
    /**
     * @internal
     */
    function fromKeyframesRule(json) {
        return Trampoline.traverse(json.rules, Rule.fromRule).map((rules) => KeyframesRule.of(json.name, rules));
    }
    KeyframesRule.fromKeyframesRule = fromKeyframesRule;
})(KeyframesRule || (KeyframesRule = {}));
//# sourceMappingURL=keyframes.js.map